export type MxUser = {
  id: string;
  guid?: string;
  birthdate?: string; // ISO 8601 YYYY-MM-DD
  gender?: "MALE" | "FEMALE";
  first_name?: string;
  last_name?: string;
  metadata?: string;
  credit_score?: number;
  email?: string;
  phone?: string;
  zip_code?: string;
  is_disabled?: boolean;
  logged_in_at?: number; // Unix Epoch format
};

export type MxMember = {
  aggregated_at: string;
  connection_status_message: string;
  external_guid: string | null;
  guid: string;
  institution_code: string;
  institution_guid: string;
  is_being_aggregated: boolean;
  is_manual: boolean;
  is_managed_by_user: boolean;
  is_oauth: boolean;
  metadata: null | unknown;
  most_recent_job_guid: string;
  name: string;
  needs_updated_credentials: boolean;
  revision: number;
  successfully_aggregated_at: string;
  user_guid: string;
  is_user_created: boolean;
  connection_status_id: number;
  connection_status: "CONNECTED" | string; // there are others...
};

export type MxWidgetUrl = {
  url: string;
  type: MxWidgetType;
  user_id: MxUser["id"];
};

export enum MxWidgetType {
  accounts_widget = "accounts_widget",
  budgets_widget = "budgets_widget",
  cash_flow_widget = "cash_flow_widget",
  connect_widget = "connect_widget",
  connections_widget = "connections_widget",
  debts_widget = "debts_widget",
  finstrong_widget = "finstrong_widget",
  goals_widget = "goals_widget",
  help_widget = "help_widget",
  investments_widget = "investments_widget",
  master_widget = "master_widget",
  mini_budgets_widget = "mini_budgets_widget",
  mini_finstrong_widget = "mini_finstrong_widget",
  mini_net_worth_widget = "mini_net_worth_widget",
  mini_pulse_carousel_widget = "mini_pulse_carousel_widget",
  mini_spending_widget = "mini_spending_widget",
  mobile_master_widget = "mobile_master_widget",
  mobile_accounts_widget = "mobile_accounts_widget",
  mobile_budgets_widget = "mobile_budgets_widget",
  mobile_spending_widget = "mobile_spending_widget",
  mobile_transactions_widget = "mobile_transactions_widget",
  net_worth_widget = "net_worth_widget",
  notifications_settings_widget = "notifications_settings_widget",
  pulse_widget = "pulse_widget",
  settings_widget = "settings_widget",
  spending_widget = "spending_widget",
  transactions_widget = "transactions_widget",
  trends_widget = "trends_widget",
}
